import { render, staticRenderFns } from "./ChangeMemberPhonenumber.vue?vue&type=template&id=0f94e482&scoped=true&"
import script from "./ChangeMemberPhonenumber.vue?vue&type=script&lang=js&"
export * from "./ChangeMemberPhonenumber.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMemberPhonenumber.vue?vue&type=style&index=0&id=0f94e482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94e482",
  null
  
)

export default component.exports